export default __webpack_public_path__ + "static/media/logbook.317b6d7a.svg";